module.exports = __webpack_public_path__ + "static/media/cq_pagamenti b.fee6afca.svg";